var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bizAIIcon"},[_c('OpenBubbleChat',{attrs:{"color":_vm.color || undefined}}),_c('Star',{staticClass:"star-rotate",attrs:{"color":_vm.color || undefined}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }